<template>
  <v-card outlined>
    <v-card-text>
      <v-row no-gutters>
        <v-col md="2">
          <v-row>
            <v-col>
              <v-text-field
                v-model="filter.search"
                placeholder="Поиск по имени"
                dense
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row justify="end">
            <v-col v-if="statistics" md="5">
              <v-row>
                <v-col md="6">
                  <ul>
                    <li>Учеников в школе: {{ statistics.pupils.in_unit }}</li>
                    <li>Выдано карт ученикам: {{ statistics.pupils.all_cards }}</li>
                    <li>Учеников с картой: {{ statistics.pupils.with_card }}</li>
                    <li>Всего учеников: {{ statistics.pupils.all }}</li>
                  </ul>
                </v-col>
                <v-col md="6">
                  <ul>
                    <li>Всего в школе: {{ statistics.users.in_unit }}</li>
                    <li>Всего выдано карт: {{ statistics.users.all_cards }}</li>
                    <li>Всего с картой: {{ statistics.users.with_card }}</li>
                    <li>Всего пользователей: {{ statistics.users.all }}</li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="2">
              <Select
                v-model="filter.event"
                :items="passageEvents"
                item-text="name"
                item-value="id"
                label="Тип прохода:"
                class="fs-admin-complex-autocomplete"
                @change="getDataFromFirstPage"
                flat
                dense
                blank
              />
            </v-col>
            <v-col md="2">
              <Select
                v-model="filter.school_class"
                :items="classes"
                item-text="name"
                item-value="id"
                label="Класс:"
                class="fs-admin-complex-autocomplete"
                @change="getDataFromFirstPage"
                flat
                dense
                blank
                />
            </v-col>
            <v-col md="2">
              <Select
                v-model="filter.stashed"
                :items="stashedTypes"
                label="Тип синхронизации:"
                class="fs-admin-complex-autocomplete"
                @change="getDataFromFirstPage"
                flat
                dense
                blank
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <Table
            :headers="headers"
            :items="passesList"
            :loading="loading"
            :items-per-page="passesPerPage"
            :server-items-length="totalPasses"
            :sort-by="sort.field"
            :sort-desc="sort.desc"
            :page="page"
            @update:request="updateRequest"
            @update:sort-by="updateSortField"
            @update:sort-desc="updateSortDesc"
            class="elevation-1"
          >
            <template v-slot:item.passage_at="{ item }">
              {{ item.passage_at | dateTime }}
            </template>
            <template v-slot:item.is_in="{ item }">
              {{ item.is_in ? 'Вход' : 'Выход' }}
            </template>
            <template v-slot:item.is_stashed="{ item }">
              {{ item.is_stashed ? 'Из Архива' : 'Обычная' }}
            </template>
          </Table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { GET_ADMIN_STUDENTS_PASSAGES, GET_ADMIN_CLASSES, GET_ADMIN_STATISTICS } from '@/requests/admin'
import { Table, Select } from '@/components/common';

export default {
  name: 'StudentsVisits',
  components: {
    Table,
    Select
  },
  data() {
    return {
      headers: [
        { text: 'Дата', value: 'passage_at' },
        { text: 'ID', value: 'number', sortable: false },
        { text: 'Тип', value: 'event.name', sortable: false },
        { text: 'Турникет', value: 'gate', sortable: false },
        { text: 'Направление', value: 'is_in', sortable: false },
        { text: 'ФИО', value: 'full_name', sortable: false },
        { text: 'Должность/класс', value: 'school_class', sortable: false },
        { text: 'Примечание', value: 'reason_text', sortable: false },
        { text: 'Синхронизация', value: 'is_stashed', sortable: false },
      ],
      stashedTypes: [
        { text: 'Из архива', value: true },
        { text: 'Обычный', value: false }
      ],
      classes: [],
      passesList: [],
      page: 1,
      totalPasses: 0,
      passesPerPage: BASE.LIMIT,
      loading: false,
      statistics: null,
      filter: {
        search: '',
        event: null,
        stashed: null,
        school_class: null
      },
      sort: {
        field: undefined,
        desc: undefined
      }
    }
  },
  created() {
    this.getData()
    this.loadClasses()
    this.loadStatistics()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchVisits()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchVisits()
      }
    }
  },
  computed: {
  ...mapState({
      cardConstants: state => state.common.constants.card_events,
      passageEvents: state => {
        return state.common.constants.card_events.passage.map(evId =>
          state.common.constants.card_events.value.find(e => e.id === evId)
        )
      }
    })
  },
  methods: {
    searchVisits: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    updateRequest({ page, itemsPerPage, offset }) {
      this.passesPerPage = itemsPerPage
      this.page = page
      this.getData({ offset: offset })
    },
    getDataFromFirstPage() {
      this.page = 1
      this.getData()
    },
    updateSortDesc(desc) {
      this.sort.desc = Array.isArray(desc) ? desc[0] : desc
      this.getDataFromFirstPage()
    },
    updateSortField(field) {
      this.sort.field = Array.isArray(field) ? field[0] : field
    },
    async getData(params = {}) {
      try {
        this.loading = true
        const { data: { count, results }} = await GET_ADMIN_STUDENTS_PASSAGES({
          limit: this.passesPerPage,
          search: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          event: this.filter.event,
          is_stashed: this.filter.stashed,
          school_class: this.filter.school_class,
          ordering: this.sort.field ? `${this.sort.desc ? '-' : ''}${this.sort.field}` : null,
          ...params
        })

        this.totalPasses = count
        this.passesList = results.map(r => ({
          ...r,
          event: this.cardConstants.value.find(p => p.id === r.event),
        }))
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить проходы учеников'
        })
      } finally {
        this.loading = false
      }
    },
    async loadClasses() {
      try {
        let response = await GET_ADMIN_CLASSES()
        this.classes = response.data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    },
    async loadStatistics() {
      try {
        let { data } = await GET_ADMIN_STATISTICS()
        this.statistics = data
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить статистику по школе'
        })
      }
    }
  }
}
</script>
